import {
  Typography,
  CardHeader,
  Divider,
  Tooltip,
  IconButton,
  CardContent,
  Modal,
  Card,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { TermsAndConditionsText } from "../TermsAndConditionsText";
import { generateGtmEvent } from "../../Helpers";

interface tosProps {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

const useStyle = makeStyles((theme) => ({
  tosModal: {
    position: "absolute",
    width: "786px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  modalTitle: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "20px",
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
}));

export const TermsOfServiceModal = (props: tosProps) => {
  const classes = useStyle();
  return (
    <>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="edit-account-modal-title">
        <Card className={classes.tosModal}>
          <CardHeader
            sx={{ padding: "16px 24px" }}
            title={
              <Typography
                id="edit-account-modal-title"
                variant="h6"
                className={classes.modalTitle}>
                Terms & Conditions
              </Typography>
            }
            action={
              <Tooltip
                style={{ zIndex: "1200 !important" }}
                placement="bottom-end"
                title="Close"
                arrow
                role="tooltip"
                describeChild>
                <IconButton
                  onClick={() => {
                    generateGtmEvent({
                      event: "modal",
                      action: "close",
                      name: "onclick",
                      type: "click",
                      region: "main content",
                      section: "terms & conditions",
                      text: "close cross",
                    });
                    props.handleClose();
                  }}
                  aria-label="close edit user account"
                  className={classes.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            }
          />
          <Divider />
          <CardContent sx={{ padding: "13px 8px", maxHeight: "540px", overflow: "auto" }}>
            <TermsAndConditionsText />
          </CardContent>
        </Card>
      </Modal>
    </>
  );
};
